"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _models = require("@seedlang/models");
var _root_store = _interopRequireDefault(require("./root_store"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var WorksheetStore = /*#__PURE__*/function (_RootStore) {
  function WorksheetStore() {
    var _this;
    (0, _classCallCheck2["default"])(this, WorksheetStore);
    _this = _callSuper(this, WorksheetStore);
    _this.config = {
      model: _models.Worksheet,
      deserialize: true,
      GET: {
        index: '/worksheets',
        show: '/worksheets/:worksheetId',
        "export": '/worksheets/:worksheetId/export'
      },
      PUT: {
        update: '/worksheets/:worksheetId',
        clearVocab: '/worksheets/:worksheetId/clear_vocab',
        sortWorksheetWordsAlphabetically: '/worksheets/:worksheetId/sort_worksheet_words_alphabetically'
      },
      POST: {
        create: '/worksheets',
        removeWord: '/worksheets/remove_word',
        removeGridItem: '/worksheets/remove_grid_item',
        batchUpdate: '/worksheets/batch_update',
        batchDelete: '/worksheets/batch_delete',
        generatePdfLink: '/worksheets/:worksheetId/generate_pdf_link',
        generateCsvLink: '/worksheets/:worksheetId/generate_csv_link'
      },
      DELETE: {
        destroy: '/worksheets/:worksheetId'
      }
    };
    return _this;
  }
  (0, _inherits2["default"])(WorksheetStore, _RootStore);
  return (0, _createClass2["default"])(WorksheetStore, [{
    key: "batchDelete",
    value: function batchDelete(params, callback) {
      this.api(params, callback, 'POST', 'batchDelete');
    }
  }, {
    key: "batchUpdate",
    value: function batchUpdate(params, callback) {
      this.api(params, callback, 'POST', 'batchUpdate');
    }
  }, {
    key: "export",
    value: function _export(params, callback) {
      this.api(params, callback, 'GET', 'export');
    }
  }, {
    key: "removeWord",
    value: function removeWord(params, callback) {
      this.api(params, callback, 'POST', 'removeWord');
    }
  }, {
    key: "removeGridItem",
    value: function removeGridItem(params, callback) {
      this.api(params, callback, 'POST', 'removeGridItem');
    }
  }, {
    key: "clearVocab",
    value: function clearVocab(params, callback) {
      this.api(params, callback, 'PUT', 'clearVocab');
    }
  }, {
    key: "sortWorksheetWordsAlphabetically",
    value: function sortWorksheetWordsAlphabetically(params, callback) {
      this.api(params, callback, 'PUT', 'sortWorksheetWordsAlphabetically');
    }
  }, {
    key: "generatePdfLink",
    value: function generatePdfLink(params, callback) {
      this.api(params, callback, 'POST', 'generatePdfLink');
    }
  }, {
    key: "generateCsvLink",
    value: function generateCsvLink(params, callback) {
      this.api(params, callback, 'POST', 'generateCsvLink');
    }
  }]);
}(_root_store["default"]);
var _default = exports["default"] = new WorksheetStore();